import { IdentityProviderDetailsState } from "@idw-types/state/identity-provider-details-state";
import { IdentityProviderDetailsActionTypes, IdentityProviderDetailsActions } from "../actions/identity-provider-details-actions";

export const initialIdentityProviderDetailsState: IdentityProviderDetailsState = {
    identityProviderDetails: {
        identityProviderDetails: null,
        isLoading: false
    },
    referenceData: {
        isLoading: false,
        attributeTypeFields: null,
        attributeTypes: null,
        categories: null,
        classifications: null,
        companies: null,
        defaultScheme: null,
        loas: null,
        protocols: null,
        schemes: null,
        urlTypes: null
    }
};

export const identityProviderDetailsReducer = (
    state: IdentityProviderDetailsState = initialIdentityProviderDetailsState,
    action: IdentityProviderDetailsActions
): IdentityProviderDetailsState => {
    switch (action.type) {
        case IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS_LOADING:
            return {
                ...state,
                identityProviderDetails: {
                    ...(action.payload.isLoading
                        ? { ...initialIdentityProviderDetailsState.identityProviderDetails }
                        : { ...state.identityProviderDetails }),
                    isLoading: action.payload.isLoading
                }
            };
        case IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS:
            return {
                ...state,
                identityProviderDetails: {
                    identityProviderDetails: action.payload.identityProviderDetails,
                    isLoading: false
                }
            };
        case IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA_LOADING:
            return {
                ...state,
                referenceData: {
                    ...(action.payload.isLoading
                        ? { ...initialIdentityProviderDetailsState.referenceData }
                        : { ...state.referenceData }),
                    isLoading: action.payload.isLoading
                }
            };
        case IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA:
            return {
                ...state,
                referenceData: {
                    ...action.payload.referenceData,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};